import { Editor } from "@monaco-editor/react";
import { marked } from "marked";
import Spacer from "../../components/Spacer";

export default function KnowledgeBaseRecord({ record, onLinkedRecordClicked }) {
  return (
    <div className="knowledge-base-record">
      <div className="flex flex-gap-xl">
        <div style={{ width: "70%" }}>
          <h2 className="knowledge-base-record-title">{record.name}</h2>
          <Spacer height="var(--spaceS)" />
          <h3 className="knowledge-base-record-description">
            {record.description}
          </h3>
          <Spacer height="var(--spaceS)" />
          <div className="knowledge-base-record-content">
            {record.content !== null ? (
              record.content_language === null ||
              record.content_language === "markdown" ? (
                <>
                  <div
                    style={{
                      background: "var(--colorLightGray)",
                      width: "fit-content",
                      padding: "5px 7px",
                    }}
                  >
                    MARKDOWN
                  </div>
                  <Spacer />
                  <div
                    dangerouslySetInnerHTML={{ __html: marked(record.content) }}
                    style={{
                      whiteSpace: "pre-wrap",
                      maxHeight: "60vh",
                      overflowY: "auto",
                    }}
                  />
                </>
              ) : (
                <>
                  <div
                    style={{
                      background: "var(--colorLightGray)",
                      width: "fit-content",
                      padding: "5px 7px",
                    }}
                  >
                    {record.content_language.toUpperCase()}
                  </div>
                  <Spacer />
                  <Editor
                    value={record.content}
                    height="60vh"
                    language={record.content_language ?? "markdown"}
                    theme="vs-dark"
                    options={{
                      readOnly: true,
                      minimap: { enabled: false },
                      scrollBeyondLastLine: false,
                    }}
                  />
                </>
              )
            ) : (
              <></>
            )}
          </div>
        </div>
        <div style={{ width: "30%" }}>
          <h2>Linked records:</h2>
          <Spacer height="var(--spaceS)" />
          {record.linked_records.length > 0 ? (
            record.linked_records.map((linkedRecord, index) => {
              return (
                <>
                  <div
                    key={index}
                    style={{ cursor: "pointer" }}
                    className="knowledge-base-linked-record"
                    onClick={() => onLinkedRecordClicked(linkedRecord)}
                  >
                    {linkedRecord.name}
                  </div>
                  <Spacer height="var(--spaceXS)" />
                </>
              );
            })
          ) : (
            <div>No records are linked with the current one.</div>
          )}
        </div>
      </div>
    </div>
  );
}
